<template>
    <div class="progress border border-white bg-transparent">
        <div class="progress-bar me-auto" :class="progressBarColor" role="progressbar"
             :style="{'width':player.strength + '%'}">
            {{player.strength | float}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            player: Object
        },
        computed: {
            progressBarColor() {
                if(this.player.strength < 45){
                    return "bg-danger"
                }
                if(this.player.strength < 75){
                    return "bg-warning"
                }
                return "bg-success"
            }
        }
    }
</script>